export default "__VITE_ASSET__CutZCbmC__"